import configuration from 'globalConfiguration';
import errorHandler from 'handler/handler.error';
import eventHelper from 'helper/eventHelper';
import imageLoadHelper from 'helper/imageLoadHelper';
import overlayHelper from 'helper/overlayHelper';
import scrollHelper from 'helper/scrollHelper';

let pluginName = 'AjaxRotator',
	defaults = {
		eventContext: document,
		appendArea: 'body',
		scrollErrorIntoViewBy: 150,
	};

// The actual plugin constructor
function AjaxRotator(element, options) {
	this.element = element;

	this.options = $.extend(true, {}, defaults, options);

	this._defaults = defaults;
	this._name = pluginName;

	this.timeout = undefined;
	this.isEditMask = false;
	this.errorHandlerScrollPoint = false;

	this.overlayHelper = overlayHelper.createInstance();
	this.performanceMeasure = {};
	this.init();
}

AjaxRotator.prototype = {
	ajaxReloadElement: undefined,
	/**
	 * @type {number}
	 */
	notReadyInstancesCount: undefined,
	init: function () {
		this.addEventListeners();
		this.emitEventOnElement('AjaxRotatorInitialized', $(this.options.eventContext));
	},

	addEventListeners: function () {
		let context = $(this.options.eventContext);
		context.on('ajaxPageLoadStart', $.proxy(this.appendAjaxLoader, this));
		context.on('ajaxPageLoaded ajaxPageLoadedError', $.proxy(this.initRemoveAjaxLoader, this));
		context.ajaxError($.proxy(this.ajaxError, this));
	},

	emitEventOnElement: function (eventName, element) {
		eventHelper.emitEventOnElement(eventName, element, 'AjaxRotator');
	},

	appendAjaxLoader: function (event, action, ajaxReloadElement) {
		$('body')
			.attr('data-rotator', 'true');
		eventHelper.reset();
		let appendArea = $(this.options.appendArea);
		this.ajaxReloadElement = ajaxReloadElement;
		if (ajaxReloadElement) {
			appendArea = $(ajaxReloadElement);
		}

		imageLoadHelper.reset();

		this.performanceMeasure['action'] = action;
		this.performanceMeasure['initRotator'] = new Date().getTime();

		this.disableKeyboard();
		this.removeStinkyElements();

		this.overlayHelper.setFullscreenOverlay(true);
		this.overlayHelper.setAppendArea(appendArea);
		this.overlayHelper.displayOverlay();

		this.emitEventOnElement('stopSlider', $(document));
	},

	removeStinkyElements: function () {
		if (this.options.stinkyElementList && this.options.stinkyElementList.length > 0) {
			for (let i = 0; i < this.options.stinkyElementList.length; i++) {
				$('body')
					.find(this.options.stinkyElementList[i])
					.remove();
			}
		}
	},

	initRemoveAjaxLoader: function (event, node) {
		let that = this;
		node = $(node || document);
		this.isEditMask = node.find('#editMask').length > 0;
		$(document)
			.one('imageLoadHelperDone', function () {
				if (that.options.useErrorTooltips) {
					that.prepareErrorHandler();
				}
				if (that.CKEditorInstancesNotReady()) {
					$(document)
						.on('ckeditorReady', $.proxy(that.updateCKEditorCount, that));
				} else {
					let domDocument = $(document);
					let panelSelector = (typeof configuration.ScrollHelper.contentSelector != 'undefined'
						? configuration.ScrollHelper.contentSelector
						: configuration.global.contentArea) + configuration.global.panelSelector;
					let panelCount = domDocument.find(panelSelector).length;
					if (panelCount > 0 && !window.skipPanelCheck) {
						eventHelper.deferredEmit($.proxy(that.removeAjaxRotator, that), 'allPanelsReady', domDocument);
					} else {
						that.removeAjaxRotator();
					}
				}
			});
		imageLoadHelper.start(node);
	},

	CKEditorInstancesNotReady: function () {
		let editors = $(configuration.global.ckeditorSelector);
		this.notReadyInstancesCount = 0;
		if (editors.length > 0) {
			let instances = CKEDITOR.instances;
			for (let i = 0; i < editors.length; i++) {
				let editorId = $(editors[i])
					.attr('data-ck-instance-name') || $(editors[i])
					.attr('id') || $(editors[i])
					.attr('name');
				if (typeof instances[editorId] == 'undefined' || (instances[editorId] as any).status != 'ready') {
					this.notReadyInstancesCount = this.notReadyInstancesCount + 1;
				}
			}
			if (this.notReadyInstancesCount != 0) { return true; }
		}
		return false;
	},

	updateCKEditorCount: function () {
		if (this.notReadyInstancesCount == 0) {
			$(document)
				.off('ckeditorReady', $.proxy(this.updateCKEditorCount, this));
			this.removeAjaxRotator();
			return;
		}
		this.notReadyInstancesCount--;
		if (this.notReadyInstancesCount == 0) {
			$(document)
				.off('ckeditorReady', $.proxy(this.updateCKEditorCount, this));
			this.removeAjaxRotator();
		}
	},

	prepareErrorHandler: function () {
		if (!this.ajaxReloadElement) {
			let firstError = this.findFirstError();
			if (firstError.length > 0) {
				errorHandler.init();
			}
		}
	},

	findFirstError: function () {
		let contentArea = $(this.options.contentArea);
		if (!contentArea[0]) {
			return $([]);
		}
		let errors = contentArea[0].querySelectorAll('input.error:not([type="hidden"]), select.error, section:not(#gErrorsBox) .box.error');
		if (errors.length == 0) {
			errors = contentArea[0].querySelectorAll('.box.error');
		}
		return errors.length === 0 ? $([]) : $(errors[0]);
	},

	disableKeyboard: function () {
		$(document)
			.on('keydown.disabledKeyboard', function (e) {
				e.preventDefault();
				return false;
			});
	},

	enableKeyboard: function () {
		$(document)
			.off('keydown.disabledKeyboard');
	},

	recalculateTopPosition: function (topPosition) {
		let result = topPosition -= +this.options.defaultOffsetTop;
		return result > 0 ? result : 0;
	},

	removeAjaxRotator: function () {
		this.emitEventOnElement('beforeRemoveAjaxRotator', $(document));
		this.overlayHelper.removeOverlay();
		let scrollPoint = scrollHelper.scrollPosition,
			firstError = this.findFirstError(),
			hiddenScrollPoint = $('#scrollPoint');
		this.performanceMeasure['removeRotator'] = new Date().getTime();
		if (this.isEditMask) {
			if ($('#firstCall')
				.val() == 'true' && !this.ajaxReloadElement) {
				scrollHelper.scrollToTop();
			} else if (hiddenScrollPoint.length === 1 && hiddenScrollPoint.val() !== '') {
				scrollHelper.scrollTo(hiddenScrollPoint.val());
			} else if (scrollPoint !== null) {
				scrollHelper.scrollTo(scrollPoint);
			} else if (firstError.length > 0) {
				if (this.errorHandlerScrollPoint) {
					scrollHelper.scrollTo(this.recalculateTopPosition(this.errorHandlerScrollPoint));
					this.errorHandlerScrollPoint = false;
				} else {
					let firstAnker = $('#anker:first'),
						firstError = $('div.hasErrors:first');
					if (firstError.length > 0) {
						scrollHelper.scrollTo(this.recalculateTopPosition(firstError.offset().top));
					} else if (firstAnker.length > 0) {
						scrollHelper.scrollTo(this.recalculateTopPosition(firstAnker.offset().top));
					} else {
						scrollHelper.scrollToTop();
					}
				}
			} else {
				scrollHelper.scrollToTop();
			}
		} else {
			let firstError = $('div.box.error:first');
			if (firstError.length > 0) {
				if (firstError.closest('.panel').length === 1) {
					this.scrollToError(firstError);
				} else if (this.errorHandlerScrollPoint) {
					scrollHelper.scrollTo(this.recalculateTopPosition(this.errorHandlerScrollPoint));
					this.errorHandlerScrollPoint = false;
				} else {
					this.scrollToError(firstError);
				}
			} else if (hiddenScrollPoint.length === 1 && hiddenScrollPoint.val() !== '') {
				scrollHelper.scrollTo(hiddenScrollPoint.val());
			} else if (scrollPoint !== null) {
				scrollHelper.scrollTo(this.recalculateTopPosition(scrollPoint));
			} else {
				scrollHelper.scrollToTop();
			}
		}
		scrollHelper.resetScrollPoint();
		this.enableKeyboard();
		this.emitEventOnElement('afterRemoveAjaxRotator', $(document));

		$('body')
			.attr('data-rotator', 'false');

		this.measurePerf();
	},

	measurePerf: function () {
		this.performanceMeasure['duration'] = Math.round(this.performanceMeasure['removeRotator'] - this.performanceMeasure['initRotator']);
		window.logRemoteInfo('loadingtime', {
			duration: this.performanceMeasure['duration'],
			action: this.performanceMeasure['action'],
		});
	},

	scrollToError: function (firstError) {
		scrollHelper.scrollTo(firstError.actual('offset').top - this.options.scrollErrorIntoViewBy);
	},

	ajaxError: function (e, request, settings, message) {
		console.log('An error occured while loading an ajax request: ' + message);
	},
};

$.fn[pluginName] = function (options) {
	return new AjaxRotator(this, options);
};
